// Exibe o modal de instalação do módulo de loja
$('.nav-link.install-store').on('click', function (ev) {
  ev.preventDefault();
  $('#modal-install-store').modal('show');
});

// Ao selecionar um tema
(function () {
  'use strict';
  $('.bl-template-wrp-store input[type="radio"]').on('change', function () {
    showConfirm({
      type: 'danger',
      title: 'Atenção!',
      text: 'Ao instalar um novo tema para a loja, o seu tema atual e personalizações serão perdidas! Para instalar o novo tema, clique em "Confirmar" e depois em "Salvar Alterações".',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        handleCheckedTheme();
      },
      cancel_cb: removeCheckedTheme,
    });
  });
  if ($('.bl-template-wrp-store').length > 0) {
    handleCheckedTheme();
  }
  function handleCheckedTheme() {
    const $themeCheckedInput = $('.bl-template-wrp-store input[type="radio"]:checked');
    const type = $themeCheckedInput.data('type');
    $('#tipo').val('store');
    $('.bl-template-btns label.btn').text('Instalar');
    $themeCheckedInput.next('.bl-template').find('.bl-template-btns label.btn').text('Selecionado');
  }
  function removeCheckedTheme() {
    $('#tipo').val('store');
    $('.bl-template-btns label.btn').text('Instalar');
    $('.bl-template-wrp-store input[type="radio"]').prop('checked', false);
  }
})();
